module.exports = "/images/xlsx-fileicon.svg?be4260a30f5669bb5dff9ec6a719a5f6";